"use client";

import React from "react";
import { useTheme } from "next-themes";
import { CircleUser, Sun, Moon, Check } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  DropdownMenuShortcut,
} from "../ui/dropdown-menu";

function Usernav() {
  const { theme, systemTheme, setTheme } = useTheme();
  const userTheme = theme === "system" ? systemTheme : theme;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <CircleUser strokeWidth={1} />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56">
        <DropdownMenuLabel>Theme</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          onClick={() => {
            setTheme("light");
          }}
        >
          <Sun strokeWidth={1} />
          <span>Clair</span>
          <DropdownMenuShortcut>
            {userTheme === "light" && <Check size={16} />}
          </DropdownMenuShortcut>
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => {
            setTheme("dark");
          }}
        >
          <Moon strokeWidth={1} />
          <span>Sombre</span>
          <DropdownMenuShortcut>
            {userTheme === "dark" && <Check size={16} />}
          </DropdownMenuShortcut>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export { Usernav };
